<template>
  <div
    class="w-full border-b border-solid leading-normal relative"
    :class="{
      'border-grey-700': hasState('nested'),
      'border border-grey-800': !hasState('nested'),
      'rounded-lg': !hasState('advanced') && !hasState('flat'),
      'px-2 border': !hasState('advanced'),
      'border-grey-800': hasState('advanced') && !hasState('background')
    }"
  >
    <div
      class="w-full heading-md flex flex-row p-2 select-none justify-between"
      :class="{
        'px-2 ': hasState('advanced'),
        'px-4': hasState('background'),
        'cursor-pointer': !disabled,
        'pointer-events-none': disabled
      }"
      @click="toggle()"
    >
      <div class="flex items-center justify-start">
        <div class="pr-2 mt-1 text-grey-500">
          <iconAngleDown v-show="!open" class="w-5 h-5 fill-current" />
          <iconAngleUp v-show="open" class="w-5 h-5 fill-current" />
        </div>

        <div v-if="showGdLogo">
          <gd-logo class="w-5 h-5 pr-2"></gd-logo>
        </div>

        <span
          :class="{
            'heading-sm lg:font-normal':
              hasState('advanced') && !hasState('background')
          }"
          >{{ title }}</span
        >
      </div>

      <button
        v-if="tooltip"
        v-tooltip.left-start="{
          content: tooltip,
          classes: [
            'bg-black',
            'text-white',
            'p-1',
            'rounded',
            'max-w-xxs',
            'mt-6'
          ]
        }"
        class="mr-3 italic focus:outline-none"
      >
        <i class="fas fa-info-circle"></i>
      </button>

      <div v-if="showIndicator" class="mt-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="8"
          viewBox="0 0 8 8"
        >
          <circle cx="4" cy="4" r="4" fill="#FD6481" fill-rule="nonzero" />
        </svg>
      </div>
    </div>

    <div v-if="open" class="w-full" :class="{ 'p-2': !hasState('advanced') }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { VTooltip } from 'v-tooltip';
import iconAngleDown from '@groovepages/gd-ui-kit/assets/icon-angle-down.svg';
import iconAngleUp from '@groovepages/gd-ui-kit/assets/icon-angle-up.svg';
import GdLogo from '../assets/logo-extra-small.svg';
import mixins from '../mixins';

export default {
  name: 'ExpansionPanel',
  components: {
    GdLogo,
    iconAngleDown,
    iconAngleUp
  },
  mixins: [mixins],
  directives: { tooltip: VTooltip },
  props: {
    title: {},
    nested: {},
    advanced: {},
    background: {},
    indicator: {},
    flat: {},
    showGdLogo: { default: false },
    openOnLoad: { default: false },
    tooltip: {},
    disabled: { default: false }
  },
  data() {
    return { open: false };
  },
  computed: {
    showIndicator() {
      // return  !this.open && !!this.indicator;
      return false;
    }
  },
  mounted() {
    if (this.openOnLoad) {
      this.toggle();
    }
  },
  methods: {
    enter(element) {
      const { width } = getComputedStyle(element);

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const { height } = getComputedStyle(element);

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      // Trigger the animation.
      // We use `setTimeout` because we need
      // to make sure the browser has finished
      // painting after setting the `height`
      // to `0` in the line above.
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    leave(element) {
      const { height } = getComputedStyle(element);

      element.style.height = height;

      // Force repaint to make sure the
      // animation is triggered correctly.
      getComputedStyle(element).height;

      setTimeout(() => {
        element.style.height = 0;
      });
    },
    close() {
      this.open = false;
    },
    toggle() {
      this.open = !this.open;
      this.$nextTick(() => {
        this.$emit(this.open ? 'open' : 'close');
      });
      if (this.open && this.$parent.closeOtherPanels) {
        this.$parent.closeOtherPanels(this._uid);
      } else if (this.open && this.$parent && this.$parent.$parent && this.$parent.$parent.closeOtherPanels ) {
        this.$parent.$parent.closeOtherPanels(this._uid);
      }
    }
  }
};
</script>
